import { Typography } from "@mui/material";
import { ReactComponent as ChevronLeftIcon } from "components/Icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "components/Icons/chevron-right.svg";
import dayjs from "dayjs";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import { useState } from "react";
import { useStyles } from "../styles";

type Month = {
  name: string;
  daysCount: number;
  code: string;
};

interface Props {
  setValue: (day: string) => void;
  value?: {
    month: number;
    day: number;
  };
  closeModal: () => void;
  months: Month[];
}

export const formatDay = (day: string | number) => ("0" + day).slice(-2);

export const Calendar = ({ setValue, value, closeModal, months }: Props) => {
  const [selected, setSelected] = useState({
    month: value ? value.month : dayjs().month(),
    day: value?.day || undefined,
  });
  const [currentMonth, setCurrentMonth] = useState(
    value ? value.month : dayjs().month(),
  );
  const classes = useStyles();
  const { message } = useMessage();
  const currentMonthData = months[currentMonth || 0];
  const days = Array.from(
    { length: currentMonthData.daysCount || 0 },
    (_, i) => i + 1,
  );
  const monthShortName = currentMonthData.name.substring(0, 3);

  return (
    <div className={classes.wrapper}>
      <div className={classes.calendar}>
        <div className={classes.settingsWrapper}>
          <Typography>{monthShortName}</Typography>
          <div className={classes.chevrons}>
            <ChevronLeftIcon
              onClick={() =>
                setCurrentMonth(currentMonth === 0 ? 11 : currentMonth - 1)
              }
            />
            <ChevronRightIcon
              onClick={() =>
                setCurrentMonth(currentMonth < 11 ? currentMonth + 1 : 0)
              }
            />
          </div>
        </div>
        <div className={classes.daysWrapper}>
          {days.map((day) => {
            const isSelected =
              selected.day === day && selected.month === currentMonth;

            return (
              <div
                key={day}
                onClick={() => setSelected({ day: day, month: currentMonth })}
                className={`${classes.day} ${isSelected ? classes.daySelected : ""}`}
              >
                {day}
              </div>
            );
          })}
        </div>
      </div>

      <div className={classes.btnWrapper}>
        <OLButton onClick={closeModal}>{message({ id: "cancel" })}</OLButton>
        <OLButton
          onClick={() =>
            setValue(
              `${months[selected.month].code}-${formatDay(selected.day || 1)}`,
            )
          }
        >
          {message({ id: "save" })}
        </OLButton>
      </div>
    </div>
  );
};
